<script setup lang="ts">
const platform = useSiteConfig().platform

if (platform.slug === 'croix-rouge') {
  useScript({
    src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
    'data-domain-script': '45212f53-de68-4fdb-a947-ab74b46dab00',
  })
}

if (platform.settings.gtm) {
  useScriptGoogleTagManager({
    id: useSiteConfig().platform.settings.gtm
  })
}
</script>

<template>
  <div class="flex">
    <div class="flex-1 min-w-0" :class="[platform.menu?.length && 'header-with-menu']">
      <Header />
      <UMain>
        <slot />
      </UMain>
      <Footer />
    </div>
  </div>

</template>
